import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Analytics, Auth } from 'aws-amplify';
import { useInfoStore } from '../store/userInfo';
import { analyticsLog, devLog, logger } from '../utils/logger';

// PageTracker 컴포넌트 - 페이지 조회 추적
const PageTracker: React.FC = () => {
  const location = useLocation();
  const { userInfo } = useInfoStore();
  
  // logger.log('🔍 PageTracker 컴포넌트 렌더링');
  
  useEffect(() => {
    analyticsLog('🔍 PageTracker useEffect 실행됨', location.pathname);
    
    // 페이지 로드 시간 측정 시작
    const startTime = Date.now();
    
    try {
      // 페이지 정보 추출
      const pageName = location.pathname || '/';
      const storeId = userInfo?.storeId || '';
      const storeName = userInfo?.storeName || '';
      
      // 디버깅 로그
      analyticsLog(`🔍 페이지 조회: ${pageName}`, {
        storeId,
        storeName,
        path: location.pathname,
        search: location.search
      });
      
      // 페이지 속성 구성
      const attributes = {
        pageName,
        path: location.pathname,
        search: location.search,
        referrer: document.referrer,
        url: window.location.href,
        hostname: window.location.hostname,
        title: document.title,
        storeId: storeId.toString(),
        storeName,
        partitionKey: storeName || storeId.toString() || 'unknown_store',
        timestamp: new Date().toISOString(),
        screenWidth: window.innerWidth.toString(),
        screenHeight: window.innerHeight.toString(),
        platform: navigator.userAgent,
        success: 'true',
        eventCategory: 'page'
      };
      
      logger.log('⏱️ setTimeout 설정 전');
      
      // setTimeout을 사용하여 페이지가 완전히 로드된 후 이벤트 전송
      setTimeout(async () => {
        logger.log('⏱️ setTimeout 콜백 시작');
        try {
          // STS 자격 증명 발급
          // const credentials = await Auth.currentCredentials();
          // logger.log('identityId:', credentials.identityId); // string 이면 OK
          // logger.log('credentials:', credentials); // accessKeyId, secretKey 있어야 정상
          
          // 간단한 로드 시간 계산 (페이지 렌더 시간)
          const loadTime = Date.now() - startTime;
          
          logger.log('⏳ Pinpoint 이벤트 기록 시작...');
          // Amplify Analytics로 이벤트 직접 기록
          Analytics.record({
            name: 'page_view',
            attributes,
            metrics: { loadTime }
          });
          
          logger.log(`✅ 페이지 조회 이벤트 전송 완료: ${pageName} (로드 시간: ${loadTime}ms)`);
        } catch (error: any) {
          logger.error(`❌ 페이지 조회 이벤트 전송 실패: ${pageName}`, error);
          logger.error('오류 메시지:', error.message);
          logger.error('오류 스택:', error.stack);
          logger.error('오류가 발생한 시간:', new Date().toISOString());
          
          // 게스트 모드 확인 시도
          try {
            logger.log('🔍 Amplify 구성 확인 중...');
            // 에러 발생 시 추가 정보 로깅
            logger.log('사용자 정보:', userInfo ? 'userInfo 있음' : 'userInfo 없음');
            logger.log('파티션 키:', attributes.partitionKey);
          } catch (extraError) {
            logger.error('추가 정보 확인 실패:', extraError);
          }
        }
      }, 100); // 약간의 지연 시간을 두고 실행
      
      logger.log('⏱️ setTimeout 설정 후');
      
    } catch (error) {
      logger.error('페이지 조회 추적 중 오류 발생:', error);
    }
    
    // 클린업 함수
    return () => {
      logger.log('🧹 PageTracker useEffect 클린업');
    };
  }, [location.pathname, location.search, userInfo]);
  
  // 컴포넌트는 UI를 렌더링하지 않음
  return null;
};

export default PageTracker; 